import React from "react";

/** Ensure shareable URLs work when pasted without scheme (e.g. www.youtube.com/...) */
export function normalizeSocialUrl(url) {
  const s = String(url || "").trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  return `https://${s}`;
}

/**
 * @param {{ instagram?: string, youtube?: string, facebook?: string }} social - from CMS `home.socialLinks`
 * @param {"topbar" | "footer" | "mobile"} variant
 */
export default function SocialMediaIcons({ social, variant = "footer", className = "" }) {
  const ig = normalizeSocialUrl(social?.instagram);
  const yt = normalizeSocialUrl(social?.youtube);
  const fb = normalizeSocialUrl(social?.facebook);
  if (!ig && !yt && !fb) return null;

  const wrap =
    variant === "topbar"
      ? "party-boss-social party-boss-social--topbar"
      : variant === "mobile"
        ? "party-boss-social party-boss-social--mobile"
        : "party-boss-social party-boss-social--footer";

  const linkCls =
    variant === "topbar"
      ? "party-boss-social__link party-boss-social__link--topbar"
      : variant === "mobile"
        ? "party-boss-social__link party-boss-social__link--mobile"
        : "party-boss-social__link party-boss-social__link--footer";

  const iconCls =
    variant === "footer"
      ? "party-boss-social__icon party-boss-social__icon--footer"
      : "party-boss-social__icon";

  return (
    <div
      className={[wrap, className].filter(Boolean).join(" ")}
      role="navigation"
      aria-label="Social media"
    >
      {ig ? (
        <a
          href={ig}
          target="_blank"
          rel="noopener noreferrer"
          className={linkCls}
          aria-label="Party Boss on Instagram"
        >
          <i className={`bi bi-instagram ${iconCls}`} aria-hidden />
        </a>
      ) : null}
      {yt ? (
        <a
          href={yt}
          target="_blank"
          rel="noopener noreferrer"
          className={linkCls}
          aria-label="Party Boss on YouTube"
        >
          <i className={`bi bi-youtube ${iconCls}`} aria-hidden />
        </a>
      ) : null}
      {fb ? (
        <a
          href={fb}
          target="_blank"
          rel="noopener noreferrer"
          className={linkCls}
          aria-label="Party Boss on Facebook"
        >
          <i className={`bi bi-facebook ${iconCls}`} aria-hidden />
        </a>
      ) : null}
    </div>
  );
}
